import { routes } from "@songtradr-one/shared-common";
import { NotificationAction } from "../NotificationActions.Parts";

// TEXT

// STYLES

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS
/** Opens the Invited tab, where the sent invitations are listed. */
export const inviteBatchAction: NotificationAction = ({ client, navigate }) => {
  // The list may have been cached before the batch finished sending
  client.cache.evict({ fieldName: "orgUserInvites" });
  client.cache.gc();

  navigate(routes.orgs.usersInvited);
};

// ASSETS
